import { DataTableColumnHeader } from "@/components/ui";
import { type MatterTaskPlan } from "@/lib/types";
import { MultiValueCell } from "@/lib/utils/tableUtils";
import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<
  MatterTaskPlan & { incidentType: string[] }
>();

export const matterTaskPlanTableColumns: ColumnDef<
  MatterTaskPlan & { incidentType: string[] }
>[] = [
  columnHelper.accessor("title", {
    id: "Title",
    enableHiding: false,
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  columnHelper.accessor("description", {
    id: "Description",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (cell) => cell.getValue() ?? "-",
  }),
  columnHelper.accessor("incidentType", {
    id: "Incident Type",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (cell) => <MultiValueCell value={cell.getValue()} />,
  }),
] as ColumnDef<MatterTaskPlan & { incidentType: string[] }>[];
